import { Injectable } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { DomQueryService } from '../dom-query';
import { GoogleMapsSettingsRepository } from './google-maps-settings.repository.http';

@Injectable()
export class GoogleMapsSettingsService {
  isApiLoaded = false;

  constructor(
    private googleMapsSettingsRepository: GoogleMapsSettingsRepository,
    private domQueryService: DomQueryService,
  ) {}

  loadMap(configKey?: string): Observable<boolean> {
    if (!this.isApiLoaded) {
      return this.googleMapsSettingsRepository.lazyLoadAPI(configKey).pipe(
        map(() => {
          this.isApiLoaded = true;
          return true;
        }),
        catchError(() => of(false)),
      );
    } else {
      return of(true);
    }
  }

  removeMap(): void {
    this.isApiLoaded = false;
    const existingScript = this.domQueryService.querySelector('script[src*="maps.googleapis.com/maps/api/js"]');
    if (existingScript) {
      existingScript.remove();
      delete (window as any).google?.maps;
    }
  }
}
